import { render } from "./DashboardBox.vue?vue&type=template&id=7f48024a"
import script from "./DashboardBox.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardBox.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Common/Helpers/DashboardBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f48024a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f48024a', __exports__)) {
    api.reload('7f48024a', __exports__)
  }
  
  module.hot.accept("./DashboardBox.vue?vue&type=template&id=7f48024a", () => {
    api.rerender('7f48024a', render)
  })

}


export default __exports__